import { Clickable } from '@carvana/merch-components';
import createComponent from '@carvana/merch-components/createComponent';
import cx from 'classnames';
import ArrowDown from '~/icons/ArrowDown';

export const DownArrow = createComponent(ArrowDown, {
  className: 'ml-4 h-[10px] w-[9px]'
});

export const UpArrow = createComponent(DownArrow, {
  className: 'rotate-180'
});

export const InternalLinkModTitle = createComponent('h3', {
  className: 'text-blue-6 tl-label-l'
});

export const InternalLinkModOverview = createComponent('div', {
  className: 'bg-white py-48 text-center'
});

export const InternalModLinks = createComponent('div', {
  className: 'mx-auto flex flex-col text-center sm:inline-block sm:w-[90%]'
});

export const InternalLinkModArea = createComponent('div', {
  className: cx(
    'flex flex-col items-center justify-start sm:flex-row sm:flex-wrap lg:justify-start',
    'py-20 align-top lg:text-left'
  )
});

export const InternalLinkStyle = createComponent('a', {
  className: 'text-nowrap capitalize text-blue-2 tl-body-l'
});

export const InternalLinkWrapper = createComponent('div', {
  className: 'basis-full p-8 text-center md:basis-1/3'
});

export const ViewMoreButton = createComponent(Clickable, {
  className: 'text-blue-2 tl-label-m sm:tl-label-l'
});
